import { Theme } from 'shared/types';

export const THEMES: Theme[] = [
  { name: 'light', color: '#ffffff' },
  { name: 'dark', color: '#1f2023' },
];
